import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useForm } from "react-hook-form";

import useModalHelper from '/src/components/modal/hooks/useModalHelper';
import Modal from '/src/components/modal/Modal';
import Form from "/src/components/form/Form";
import ButtonAction from "/src/components/UI/Button/Button";
import Field from '/src/components/UI/Field/Field';
import TextInput from '/src/components/UI/TextField/TextInput';
import "./BlockCategoryModal.css"
import CheckBox from "/src/components/UI/CheckBox/CheckBox";
import Dropdown from "/src/components/UI/DropDown/DropDown";
import { ColorCategoryPrefab } from "./ColorCategoryPrefab";
import useCategories from "../../../hook/category/useCategories";
import editorAction from "../../../actions/editorAction";

const BlockCategoryModal = NiceModal.create(({ category }) => {
    const modal = useModal();
    const { onClose } = useModalHelper(modal);
    
    const { register, handleSubmit, getValues, setValue, watch, formState: { errors }, formState } = useForm({
        mode: "onChange",
        defaultValues: {
            name: category.name,
            color: category.color,
            note: category.categories_notes[0].description,

        }
    })

    if (ColorCategoryPrefab.some(item => item.value === category.color) == false){
        ColorCategoryPrefab.push({
            value: category.color,
            text: <span><i className="fas fa-cube" style={{ color: category.color }}></i> </span>
        
    })
    }

    const onSubmit = async () => {
        let dataToSend = getValues();
        modal.resolve(dataToSend);
        onClose();
    }

    return (
        <Modal name="change-password" id={modal.id} autoClose="true" onClose={onClose} >
            <Form className="block_category_modal" onSubmit={handleSubmit(onSubmit)}>

                <Form.Title> Update Category</Form.Title>

                <Form.Body className={"category_modal_form_center"}>

                    <div className={"category_form_column_title"}>
                        <Field label={"Category's name"} listLabelClassName="field-modal" />
                        <TextInput {...register('name', { required: true, minLength: 3 })} placeholder={"Enter the label of the category"} className={"statement_form_column_text_input"} style={errors.name ? { borderColor: "red" } : {}}></TextInput>
                        <span className='error' style={{ fontSize: "14px", marginTop: "5px", height: "10px" }}>{errors.name ? (errors.name.message ? errors.name.message : "At least 3 letters") : ""}</span>
                    </div>
                    
                    <div className="color_perso_checkbox title_container">
                        <Field label="Perso color" listLabelClassName={"field-modal"} />
                        <div >
                            <CheckBox  {...register('color_perso')} name={"color_perso"} onChange={(val) => setValue("color_perso", val.target.checked)} checked={false}></CheckBox>
                        </div>
                    </div>
                    
                    {
                        watch("color_perso") == true ?
                            <div className="color_container">
                                <Field label="Color of the category" listLabelClassName="label_color" listClassName="field_color" />
                                <div className="color_area">
                                    <div className="category_form_column_color">
                                        <input  {...register('color')} defaultValue={category.color} type="color" className="input_color"></input>
                                    </div>
                                </div>
                            </div>
                            :
                            <div className={"color_prefab_list_container title_container"} style={{ gap : "15%", marginLeft: "0px", marginBottom: "15px" }}>
                                <Field label="Color prefab" listLabelClassName="field-modal"></Field>
                                <div>
                                    <Dropdown {...register('color')} setValue={setValue} choices={ColorCategoryPrefab} width="100px" defaultChoice={category.color}></Dropdown>
                                </div>
                            </div>
                    }

                    <div className={"category_form_column_title"}>
                        <Field label={"Category's note"} listLabelClassName="field-modal" />
                        <TextInput {...register('note')} placeholder={"Enter your note"} className={"statement_form_column_text_input"}></TextInput>
                    </div>
                </Form.Body>
                <Form.Buttons>
                    <ButtonAction className="cancel" label="Cancel" type="button" onClick={() => onClose()} style={{ marginRight: "20px" }} />
                    <ButtonAction className="validate" label="Update" type="submit" disabled={!formState.isValid} />

                </Form.Buttons>

            </Form>
        </Modal>
    );
});

export default BlockCategoryModal;